import { defineMessages } from 'react-intl';

export default defineMessages({
  text: {
    id:
      'app.conversion.shopsDetails.components.SelectedLocationPointToast.text',
    defaultMessage: '{shopName} entrega en tu dirección!',
  },
});
